<nav
    *ngIf="userState?.impersonator"
    class="agpr-impersonatorBanner"
>
    {{ 'PrimaryNav.ghost.part1' | localize }}
    <span class="agpr-impersonatorBanner-user">
        {{ userState?.user?.username }}
    </span>
    {{ 'PrimaryNav.ghost.part2' | localize }}
    <span class="agpr-impersonatorBanner-account">
        {{ userState?.account?.name }}.
    </span>
    <a
        tabindex="0"
        (click)="ghostOut()"
        class="agpr-impersonatorBanner-ghostLink"
    >
        {{ 'PrimaryNav.ghost.logout' | localize }}
    </a>
</nav>
<span
    [agprLoading]="loading"
    [agprGlobalLoading]="true"
></span>
